import { memo } from 'react';
import { ErrorOutline } from '@mui/icons-material';
import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import aiMusicGenerator from 'services/locales/en/aiMusicGenerator';
import theme from 'theme';

const ErrorMessage = () => {
  const { t } = useTranslation();
  return (
    <Alert
      variant="standard"
      severity="error"
      color="error"
      data-testid="errorAlert"
      icon={<ErrorOutline color="error" />}
      sx={{
        backgroundColor: 'transparent !important',
        fontWeight: 'light',
        color: theme.palette.error.main,
      }}
    >
      {t(aiMusicGenerator.sideBar.errorMessage)}
    </Alert>
  );
};

export default memo(ErrorMessage);
